import { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

type MarkProps = {
  when: boolean;
  children: ReactNode;
  label?: string;
};

export function Mark({ when, children, label }: MarkProps) {
  if (!when) {
    return children;
  }

  const mark = (
    <mark className="rounded-sm bg-amber-100 px-0.5 ring-1 ring-amber-300">
      {children}
    </mark>
  );

  if (!label) {
    return mark;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{mark}</TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
